<template>
  <v-app>
    <app-snackbar
      :text="snackBarText"
      :show.sync="snackbar"
      :color="snackbarColor"
      :timeOut="timeOut"
    ></app-snackbar>
    <v-container class="pass-change">
      <v-layout row>
        <v-flex xs12 sm6 offset-sm3>
          <v-container class="medium-div">
            <v-container class="without-padding container-img">
              <v-img :src="require('../../assets/logoPonce.png')" />
            </v-container>
            <p class="text-title">{{$t('PassChange.setNewPassword')}}</p>
            <v-form v-model="validInput" @submit.prevent="onPassRecovery">
              <v-layout row>
                <v-text-field class="input-password"
                  :append-icon="passShow1 ? 'visibility' : 'visibility_off'"
                  @click:append="passShow1 = !passShow1"
                  prepend-inner-icon="lock"
                  name="passwordNew"
                  :label="$t('PassChange.newPassword')"
                  id="passwordNew"
                  v-model="passwordNew"
                  :type="passShow1 ? 'text' : 'password'"
                  color="#0098E1"
                  :rules="$ponceConfig.passwordRules"
                  required></v-text-field>
              </v-layout>
              <v-layout row>
                <v-text-field class="input-password"
                  :append-icon="passShow2 ? 'visibility' : 'visibility_off'"
                  @click:append="passShow2 = !passShow2"
                  prepend-inner-icon="lock"
                  name="passwordConfirm"
                  :label="$t('PassChange.confirmPassword')"
                  id="passwordConfirm"
                  v-model="passwordConfirm"
                  :type="passShow2 ? 'text' : 'password'"
                  color="#0098E1"
                  :rules="$ponceConfig.passwordRules"
                  required></v-text-field>
              </v-layout>
              <v-layout v-if="showError" row>
                <p class="error-text">{{$t('PassChange.differentPasswords')}}</p>
              </v-layout>
              <v-layout row class="submit-layout">
                <v-flex xs12>
                  <div class="text-center">
                    <v-btn class="submit-btn" block color="info" type="submit">
                      {{$t('PassChange.setPassword')}}</v-btn
                    >
                  </div>
                </v-flex>
              </v-layout>
              <div class="text-center div-reset-password">
                <a @click="signIn" class="text-reset-password"
                  ><u>{{$t('PassChange.signIn')}}</u></a
                >
              </div>
            </v-form>
            <div class="bottom-div">
              <p class="bottom-text">PONCE</p>
            </div>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import { auth } from '@/plugins/firebase'
export default {
  data () {
    return {
      passShow1: false,
      passShow2: false,
      dialog: false,
      passwordNew: '',
      passwordConfirm: '',
      snackbar: false,
      snackBarText: '',
      snackbarColor: '',
      timeOut: 5000,
      validInput: '',
      showError: false
    }
  },
  created () {
    if (this.$store.getters.userAuth) {
      this.$router.push('/dashboard')
    }
  },
  methods: {
    signIn () {
      this.$router.push({ name: 'Signin' })
    },
    onPassRecovery () {
      if (!this.$store.getters.isOnline) {
        this.snackbar = true
        this.snackBarText = this.$t('PassChange.noConnection')
        this.snackbarColor = 'red'
        return
      }
      if (this.validInput) {
        if (this.passwordNew === this.passwordConfirm) {
          this.showError = false
          const passResetToken = this.$router.currentRoute.query && this.$router.currentRoute.query.oobCode ? this.$router.currentRoute.query.oobCode : ''
          const that = this
          auth.confirmPasswordReset(passResetToken, this.passwordNew)
          .then(() => {
            this.snackbar = true
            this.snackBarText = this.$t('PassChange.passwordSetted')
            this.snackbarColor = '#0098E1'
            setTimeout(function () {
              if (that.$route.query.continueUrl) {
                window.location.href = that.$route.query.continueUrl
              } else {
                that.$router.push('/signin')
              }
            }, this.timeOut)
          })
          .catch(() => {
            this.snackbar = true
            this.snackBarText = this.$t('PassChange.invalidToken')
            this.snackbarColor = 'red'
          })
        } else {
          this.showError = true
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// PassChange.vue?c184565c